<template>
  <v-card class="card" color="primary">
    <v-card-text>
      <v-row>
        <v-col cols="4">
          <v-autocomplete
            :value="idEvaluador"
            @change="$emit('update:idEvaluador', $event)"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            :items="evaluadores"
            item-value="idPersonal"
            item-text="CUIP"
            item-color="secondary"
            :rules="required"
            hint="Presione la tecla Enter para realizar la búsqueda"
            persistent-hint
            @keyup.enter="fetchEvaluadores($event.target.value)"
          >
            <template v-slot:label>Personal evaluador <span class="red--text">*</span> </template>
            <template v-slot:item="data">
              <v-list-item-avatar>
                <v-img v-if="data.item.foto !== ''" :src="data.item.foto"></v-img>
                <v-icon v-else>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ data.item.CUIP }}</v-list-item-title>
                <v-list-item-subtitle>{{ getFullName(data.item) }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="4">
          <v-menu
            v-model="menuFecha"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
            :disabled="editMode"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="fechaFormatted"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                :rules="required"
                :disabled="editMode"
              >
                <template v-slot:label>Fecha de aplicación <span class="red--text">*</span> </template>
              </v-text-field>
            </template>
            <v-date-picker
              @change="$emit('update:fechaAplicacion', $event)"
              @input="menuFecha = false"
              :disabled="editMode"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="4">
          <BaseSelect
            :value="tipoEvaluacion"
            label="Tipo de evaluación"
            :items="[
              { id: 8, title: 'EVACOM' },
              { id: 9, title: 'EVACOM (Mando medio)' },
            ]"
            :rules="required"
            :disabled="editMode"
            @change="$emit('update:tipoEvaluacion', $event)"
          />
        </v-col>
      </v-row>
      <hr class="my-4" />
      <DatosGeneralesEvaluadoSection :personal="personal" />
      <template v-if="selectedEvaluador">
        <hr class="my-4" />
        <DatosGeneralesEvaluadorSection :personal="selectedEvaluador" />
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { VUETIFY_DATE_FORMAT } from '@src/const'
import moment from 'moment'
import BaseSelect from '@src/components/base/BaseSelect.vue'
import { mapActions, mapGetters } from 'vuex'
import DatosGeneralesEvaluadoSection from './DatosGeneralesEvaluadoSection.vue'
import DatosGeneralesEvaluadorSection from './DatosGeneralesEvaluadorSection.vue'

export default {
  components: { BaseSelect, DatosGeneralesEvaluadoSection, DatosGeneralesEvaluadorSection },

  props: {
    personal: {
      type: Object,
      required: true,
    },

    tipoEvaluacion: {
      type: Number,
      default: 8,
    },

    fechaAplicacion: {
      type: String,
      default: '',
    },

    idEvaluador: {
      type: Number,
      default: null,
    },

    editMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      menuFecha: false,
      required: [(v) => !!v || 'Este campo es requerido'],
    }
  },

  computed: {
    ...mapGetters('personal', { evaluadores: 'getEvaluadores' }),

    fechaFormatted: function () {
      return this.fechaAplicacion ? moment(this.fechaAplicacion, VUETIFY_DATE_FORMAT).format(this.API_DATE_FORMAT) : ''
    },

    selectedEvaluador: function () {
      return this.evaluadores.find((e) => e.idPersonal === this.idEvaluador) ?? null
    },
  },

  methods: {
    ...mapActions('personal', ['fetchEvaluadores']),
  },
}
</script>
